module.exports = __webpack_public_path__ + "static/img/Agronomy 13.f2719ebd.webp";